import { render, staticRenderFns } from "./LegacyLoanAllocationModal.vue?vue&type=template&id=40e54754"
import script from "./LegacyLoanAllocationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegacyLoanAllocationModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e54754')) {
      api.createRecord('40e54754', component.options)
    } else {
      api.reload('40e54754', component.options)
    }
    module.hot.accept("./LegacyLoanAllocationModal.vue?vue&type=template&id=40e54754", function () {
      api.rerender('40e54754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/LegacyLoanAllocationModal.vue"
export default component.exports